module.exports = __webpack_public_path__ + "assets/img/index-partner4.3bd78a9d.jpg";